import { defineMessages } from 'react-intl';

export default defineMessages({
  textSearchFilterPlaceholder: {
    id: 'frontbucket.jiraTab.textSearchFilter.placeholder',
    description:
      'Placeholder text for search box which filters a list of issues by text',
    defaultMessage: 'Search issues',
  },
});
